import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {catchError, map} from 'rxjs/operators';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import {endpoints} from '../common/api-endpoints';
import {DataService} from './data.service';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceService extends DataService {
  constructor(http: HttpClient, private api: APIHelper) {
    super(endpoints.workspace, http);
  }
  async updateEmoji(workspaceId, emoji) {


    const res: any = await this.http.put(`${this.url}emoji/${workspaceId}`, { emoji }).toPromise();
    return res;
  }


  getTree() {
    return this.http.get(this.url + 'tree')
      .pipe(
        map(response => response),
        catchError(this.handleError));
  }

  getArchivedTree() {
    return this.http.get(this.url + 'tree/archived')
      .pipe(
        map(response => response),
        catchError(this.handleError));
  }
}
